import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { prettifyMoney, prettifyNumber } from '@nexio/emvio-util-app';

import Widget from '../Widget/Widget';

import './TransactionsWidget.scss';

export default class TransactionsWidget extends Component {
    static propTypes = {
        currencyCode: PropTypes.string,
        lastThirtySaleCount: PropTypes.number,
        lastThirtyVsPreviousThirtySaleCount: PropTypes.number,
        yesterdayAverageSaleAmount: PropTypes.number,
        yesterdayVsLastThirtyAverageSaleAmount: PropTypes.number
    };

    renderSide(data) {
        return (
            <Fragment>
                <div className="widget-heading">{data.title}</div>
                <div className="widget-value">{data.value}</div>
                <div className="widget-delta">
                    <span className="material-icons">
                        {data.deltaDirection === 'up' ? 'arrow_drop_up' : 'arrow_drop_down'}
                    </span>
                    {data.deltaText}
                </div>
            </Fragment>
        );
    }

    render() {
        const { yesterdayAverageSaleAmount, lastThirtySaleCount } = this.props;

        const averageTicket = {
            title: 'Yesterdays Average Ticket',
            value: yesterdayAverageSaleAmount ? prettifyMoney(yesterdayAverageSaleAmount, this.props.currencyCode) : '--',
            deltaText: `${prettifyNumber(Math.abs(this.props.yesterdayVsLastThirtyAverageSaleAmount), 0, 1)}% from last 30 days`,
            deltaDirection: this.props.yesterdayVsLastThirtyAverageSaleAmount > 0 ? 'up' : 'down'
        };

        const ticketCount = {
            title: 'Last 30 Days Transaction Count',
            value: prettifyNumber(lastThirtySaleCount),
            deltaText: `${prettifyNumber(Math.abs(this.props.lastThirtyVsPreviousThirtySaleCount), 0, 1)}% from previous 30 days`,
            deltaDirection: this.props.lastThirtyVsPreviousThirtySaleCount > 0 ? 'up' : 'down'
        };

        return (
            <div className="transactions-widget widget-layout">
                <div className="widget-title">
                    Transactions
                </div>
                <Widget
                    left={this.renderSide(averageTicket)}
                    right={this.renderSide(ticketCount)}
                    varient="dark"
                />
            </div>
        );
    }
}
